import { Fragment } from 'react'
import { Grid, Typography } from '@mui/material'

import { State } from '@ecm/data/State'
import Anchor from '@ecm/ui/element/Anchor'
import useSmallScreen from '@ecm/ui/hook/UseSmallScreen'

type StateCardProps = Pick<State, 'name' | 'areas' | 'slug'>

export const StateCard = ({ name, areas, slug }: StateCardProps) => {
  const isSmallScreen = useSmallScreen()

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      sx={{
        background: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0px 10px 20px rgba(75, 79, 99, 0.07)',
        height: '100%',
        padding: '24px',
      }}
    >
      <Grid item>
        <Typography variant="h5" component="h3">
          {name}
        </Typography>
        {areas.map(area => (
          <Fragment key={area.slug}>
            <Anchor href={`/addresses/${area.stateAbbreviation}/${area.city}`}>
              {area.cityDisplay}
            </Anchor>
            <br />
          </Fragment>
        ))}
      </Grid>
      <Grid item alignSelf={{ sm: 'flex-start', xs: 'flex-end' }} marginTop={{ sm: 0, xs: '1em' }}>
        <Anchor href={`/addresses/${slug}`} caret>
          {isSmallScreen ? 'See all' : `See all ${name} addresses`}
        </Anchor>
      </Grid>
    </Grid>
  )
}

export default StateCard
